import z from "zod";

import { PAGE_HEADER_VARIANTS } from "./constants";

export const pageHeaderDataSchema = z.object({
  icon: z
    .string()
    .optional()
    .describe(
      "Lucide icon name shown in the header. Omit it when a `pageHeaderVisual` supplies the left column instead.",
    ),
  variant: z.enum(PAGE_HEADER_VARIANTS).optional(),
});

export type PageHeaderDataProps = z.infer<typeof pageHeaderDataSchema>;

export const pageHeaderPartDataSchema = z.object({});

export type PageHeaderPartDataProps = z.infer<typeof pageHeaderPartDataSchema>;

export const pageHeaderVisualDataSchema = z.object({
  icon: z
    .string()
    .optional()
    .describe(
      "Lucide icon name filling the visual. Omit it to project slotted content instead.",
    ),
  variant: z
    .enum(PAGE_HEADER_VARIANTS)
    .optional()
    .describe(
      "Chrome of the visual alone, `plain` for a slotted avatar in a `card` header. Follows the header when omitted.",
    ),
});

export type PageHeaderVisualDataProps = z.infer<
  typeof pageHeaderVisualDataSchema
>;

export const pageHeaderBreadcrumbDataSchema = z.object({
  icon: z
    .string()
    .optional()
    .describe("Optional Lucide icon name shown before the breadcrumb."),
});

export type PageHeaderBreadcrumbDataProps = z.infer<
  typeof pageHeaderBreadcrumbDataSchema
>;

export const pageHeaderActionsDataSchema = z.object({
  menuLabel: z
    .string()
    .optional()
    .describe("Accessible name for the overflow menu trigger."),
});

export type PageHeaderActionsDataProps = z.infer<
  typeof pageHeaderActionsDataSchema
>;
